import protocolSender from "../util/protocol-sender"
import Store from "../util/store"
import eventRegistry from "../../common/event-registry"

class MessageManager {
  constructor() {
    Store.msgDispatcher.addMsgHandler(11000, this._onRecvUserMsg.bind(this));
    Store.msgDispatcher.addMsgHandler(11006, this._onRecvGroupMsg.bind(this));
    Store.msgDispatcher.addMsgHandler(11010, this._onRecvServerAck.bind(this));
  }

  /**
   * 发送单播消息
   * @param {*} params 
   */
  sendUserMsg(params) {
    protocolSender.sendUserMsg(params);
  };

  /**
   * 发送白名单消息
   * @param {*} params 
   */
  sendGroupMsgWithWhiteList(params) {
    protocolSender.sendGroupMsgWithWhiteList(params);
  };

  /**
   * 发送黑名单消息
   * @param {*} params 
   */
  sendGroupMsgWithBlackList(params) {
    protocolSender.sendGroupMsgWithBlackList(params);
  };

  /**
   * 发送广播消息
   * @param {*} params 
   */
  sendGroupMsg(params) {
    protocolSender.sendGroupMsg(params);
  };

  /**
   * 收到用户消息
   * @param {*} data 
   */
  _onRecvUserMsg(data) {
    eventRegistry.trigger("onRecvUserMsg", {
      srcUserId: data.src_user_id,
      msg: data.msg,
      msgId: data.msg_id
    });
    protocolSender.sendUserMsgAck(data);
  };

  /**
   * 收到分组消息
   * @param {*} data 
   */
  _onRecvGroupMsg(data) {
    eventRegistry.trigger("onRecvGroupMsg", {
      srcUserId: data.src_user_id,
      groupId: data.group_id,
      msg: data.msg,
      msgId: data.msg_id
    });
    protocolSender.sendGroupMsgAck(data);
  }

  /**
   * 收到服务器Ack消息，说明服务器已经收到
   * @param {*} data 
   */
  _onRecvServerAck(data) {
    // TODO: 暂时不做处理
  }
}

export default new MessageManager();